/* Pawganix Halloween Treat landing page. No dependencies. Reads its settings from the JSON in #pgxh-config. */
(function () {
  'use strict';
  var root = document.querySelector('.pgxh');
  if (!root) return;
  var cfgEl = document.getElementById('pgxh-config');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var OPEN = Date.parse(CFG.opensAt);   // doors open (UTC instant)
  var CLOSE = Date.parse(CFG.closesAt); // doors close (UTC instant)
  var qs = new URLSearchParams(location.search);
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- clock: real time, or a simulated time for testing ---------- */
  var offset = 0; // ms added to the real clock
  if (previewAllowed() && qs.get('now')) {
    var sim = Date.parse(qs.get('now') + (/[zZ]|[+-]\d\d:?\d\d$/.test(qs.get('now')) ? '' : '-04:00'));
    if (!isNaN(sim)) offset = sim - Date.now();
  }
  function now() { return Date.now() + offset; }
  function previewAllowed() {
    if (!CFG.allowPreview) return false;
    if (CFG.platform === 'shopify') {                 // Shopify: only in the theme editor or an unpublished theme preview, never on the live theme
      var sh = window.Shopify || {};
      return !!(sh.designMode || (sh.theme && sh.theme.role && sh.theme.role !== 'main'));
    }
    if (!CFG.previewKey) return true;                 // test site: open preview
    return qs.get('key') === CFG.previewKey;          // live site: private key required
  }
  var forced = previewAllowed() ? qs.get('state') : null;
  if (['teaser', 'live', 'closed'].indexOf(forced) < 0) forced = null;
  function clockState() { var t = now(); return t < OPEN ? 'teaser' : (t <= CLOSE ? 'live' : 'closed'); }
  var state = forced || clockState();
  /* Shopify sends the live markup (code, prices) only once the doors are open. If this copy of the
     page was made before 8am ET, fetch a fresh one instead of switching to an empty live state. */
  var refreshing = false;
  function needFresh(s) { return s === 'live' && root.getAttribute('data-has-live') === '0'; }
  function fresh() {
    if (refreshing) return; refreshing = true;
    var n = 0; try { n = +(sessionStorage.getItem('pgxh_fresh') || 0); sessionStorage.setItem('pgxh_fresh', n + 1); } catch (e) {}
    if (n >= 6) return;
    setTimeout(function () { var u = new URL(location.href); u.searchParams.set('pgxh', Date.now()); location.replace(u.toString()); }, n ? 15000 : Math.random() * 3000);
  }
  if (root.getAttribute('data-has-live') === '1') { try { sessionStorage.removeItem('pgxh_fresh'); } catch (e) {} }
  if (!forced && needFresh(state)) { fresh(); state = 'teaser'; }

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'pgxh_' + name, pgxh_state: state }, params || {}));
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
      if (typeof window.fbq === 'function' && name === 'generate_lead') window.fbq('track', 'Lead', { content_name: 'Halloween RSVP' });
    } catch (e) { /* tracking must never break the page */ }
  }

  function setState(s) {
    state = s;
    root.setAttribute('data-state', s);
    var meta = (CFG.meta || {})[s];
    if (meta && forced) document.title = meta.title; // preview only: the server already printed the right title for the public
    renderTestBar();
  }

  /* ---------- countdowns ---------- */
  function parts(ms) {
    ms = Math.max(0, ms);
    var s = Math.floor(ms / 1000);
    return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var clocks = [].slice.call(root.querySelectorAll('[data-clock]'));
  var stickyTime = root.querySelectorAll('[data-sticky-time]');
  function tick() {
    var t = now();
    if (!forced) {
      var cs = clockState();
      if (cs !== state) { if (needFresh(cs)) fresh(); else { setState(cs); track('state_change', { to: cs }); } }
    }
    clocks.forEach(function (c) {
      var target = c.getAttribute('data-clock') === 'open' ? OPEN : CLOSE;
      var p = parts(target - t);
      c.querySelectorAll('[data-u]').forEach(function (u) {
        var k = u.getAttribute('data-u');
        var v = pad(k === 'h' && !c.querySelector('[data-u="d"]') ? p.h + p.d * 24 : p[k]);
        var dg = u.querySelectorAll('.dg');
        for (var i = 0; i < 2; i++) {
          if (dg[i].textContent !== v[i]) {
            dg[i].textContent = v[i];
            if (!reduce) { dg[i].classList.remove('flip'); void dg[i].offsetWidth; dg[i].classList.add('flip'); }
          }
        }
      });
    });
    var target = state === 'teaser' ? OPEN : CLOSE;
    var p = parts(target - t);
    var label = (p.d ? p.d + 'd ' : '') + p.h + 'h ' + pad(p.m) + 'm';
    for (var i = 0; i < stickyTime.length; i++) stickyTime[i].textContent = label;
  }

  /* ---------- gate (first visit, not for email traffic, not for reduced motion) ---------- */
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function initGate() {
    var gate = document.getElementById('pgxh-gate');
    if (!gate) return;
    var force = previewAllowed() && qs.get('gate') === '1';
    var fromEmail = (qs.get('utm_source') || '').toLowerCase() === 'omnisend' || /omnisend|mail/i.test(document.referrer);
    var off = previewAllowed() && qs.get('gate') === '0';
    var show = !off && (force || (state !== 'closed' && !store('pgxh_gate_seen') && !fromEmail && !reduce));
    if (!show) { gate.remove(); return; }
    gate.hidden = false;
    document.documentElement.classList.add('pgxh-lock');
    var done = false;
    function finish(how) {
      if (done) return; done = true;
      store('pgxh_gate_seen', '1');
      track('gate', { action: how });
      gate.classList.add('out');
      document.documentElement.classList.remove('pgxh-lock');
      setTimeout(function () { gate.remove(); }, 400);
      var first = root.querySelector('[data-focus-after-gate]');
      if (first && how !== 'skip') first.focus({ preventScroll: true });
    }
    function open() {
      if (gate.classList.contains('opening')) return;
      gate.classList.add('opening');
      setTimeout(function () { gate.classList.add('rising'); }, 1300);
      setTimeout(function () { finish('opened'); }, 1800);
    }
    gate.querySelectorAll('[data-gate-open]').forEach(function (b) { b.addEventListener('click', open); });
    gate.querySelector('[data-gate-skip]').addEventListener('click', function () { finish('skip'); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { finish('skip'); document.removeEventListener('keydown', esc); } });
    gate.querySelector('[data-gate-open]').focus({ preventScroll: true });
  }

  /* ---------- RSVP ---------- */
  function initRsvp() {
    var f = root.querySelector('[data-rsvp]');
    if (!f) return;
    var steps = f.querySelectorAll('[data-step]');
    var peek = f.querySelectorAll('[data-peek]'), peekBox = f.querySelector('.peek');
    var err = f.querySelector('[data-err]');
    var data = { type: 'Dog' };
    function show(n) {
      steps.forEach(function (s) { s.hidden = s.getAttribute('data-step') !== String(n); });
      var h = f.querySelector('[data-step="' + n + '"] h3');
      if (h && n !== 1) { h.setAttribute('tabindex', '-1'); h.focus(); }
      f.querySelector('.peek').hidden = n === 3;
    }
    function setPeek(type) {
      var want = type === 'Cat' ? 'cat' : (type === 'Both' ? 'both' : 'dog');
      peek.forEach(function (img) { img.classList.toggle('down', img.getAttribute('data-peek') !== want); });
      if (peekBox) peekBox.classList.toggle('both', want === 'both');
    }
    function fill(name) {
      f.querySelectorAll('[data-pet]').forEach(function (el) { el.textContent = name; });
    }
    f.querySelectorAll('input[name="pet_type"]').forEach(function (r) {
      r.addEventListener('change', function () { data.type = r.value; setPeek(r.value); track('rsvp_pet_type', { pet_type: r.value }); });
    });
    function invalid(input, on) { input.setAttribute('aria-invalid', on ? 'true' : 'false'); }
    f.querySelector('[data-next]').addEventListener('click', function () {
      var pn = f.querySelector('[name="pet_name"]');
      var v = pn.value.trim();
      if (!v) { invalid(pn, true); pn.focus(); return; }
      invalid(pn, false);
      data.pet = v.slice(0, 40);
      fill(data.pet);
      track('rsvp_step', { step: 1 });
      show(2);
    });
    f.querySelector('[name="pet_name"]').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); f.querySelector('[data-next]').click(); } });
    f.querySelector('[data-back]').addEventListener('click', function () { show(1); });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var fn = f.querySelector('[name="first_name"]'), em = f.querySelector('[name="email"]');
      var okName = fn.value.trim().length > 0;
      var okMail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim());
      invalid(fn, !okName); invalid(em, !okMail);
      if (!okName || !okMail) { err.textContent = !okName ? 'Please add your first name.' : 'Please check your email address.'; (!okName ? fn : em).focus(); return; }
      err.textContent = '';
      var btn = f.querySelector('[type="submit"]');
      btn.disabled = true; var label = btn.innerHTML; btn.textContent = 'Saving their spot...';
      var payload = { email: em.value.trim(), first_name: fn.value.trim(), pet_name: data.pet, pet_type: data.type, website: f.querySelector('[name="website"]').value, source: CFG.source || 'halloween-landing' };
      fetch(CFG.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), credentials: 'same-origin' })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) throw new Error(j.message || 'error'); return j; }); })
        .then(function () {
          f.querySelectorAll('[data-guest]').forEach(function (el) { el.textContent = payload.first_name; });
          f.querySelectorAll('[data-who]').forEach(function (el) { el.textContent = { Dog: 'Dog', Cat: 'Cat', Both: 'Dog and cat' }[data.type]; });
          show(3);
          track('generate_lead', { form: 'halloween_rsvp', pet_type: data.type });
        })
        .catch(function (x) {
          err.textContent = 'Sorry, that did not go through. Please try again in a moment.';
          btn.disabled = false; btn.innerHTML = label;
        });
    });
    /* add to calendar (.ics) */
    var cal = f.querySelector('[data-ics]');
    if (cal) cal.addEventListener('click', function () {
      var stamp = function (d) { return new Date(d).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); };
      var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Pawganix//Halloween Treat//EN', 'BEGIN:VEVENT',
        'UID:halloween-treat-2026@pawganix.com', 'DTSTAMP:' + stamp(Date.now()), 'DTSTART:' + stamp(OPEN), 'DTEND:' + stamp(OPEN + 3600000),
        'SUMMARY:The Pawganix Halloween Treat opens', 'DESCRIPTION:Doors open. Look for the orange envelope in your inbox.', 'URL:' + CFG.pageUrl,
        'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
      a.download = 'pawganix-halloween-treat.ics';
      document.body.appendChild(a); a.click(); a.remove();
      track('rsvp_calendar');
    });
    var inv = f.querySelector('[data-invite]'), toast = f.querySelector('[data-toast]');
    if (inv) inv.addEventListener('click', function () {
      var share = { title: 'The Pawganix Halloween Treat', text: 'You are invited to the Pawganix Halloween Treat, for every dog and every cat.', url: CFG.pageUrl };
      track('rsvp_invite');
      if (navigator.share) { navigator.share(share).catch(function () {}); return; }
      (navigator.clipboard ? navigator.clipboard.writeText(share.url) : Promise.reject()).then(function () { toast.textContent = 'Link copied. Send it to a friend.'; }, function () { toast.textContent = share.url; });
    });
    setPeek('Dog');
  }

  /* ---------- sneak peek: tap to reveal a hint (hover handles desktop in CSS) ---------- */
  function initGhosts() {
    root.querySelectorAll('.pgxh-ghost').forEach(function (g) {
      g.addEventListener('click', function () {
        var open = !g.classList.contains('open');
        root.querySelectorAll('.pgxh-ghost.open').forEach(function (o) { o.classList.remove('open'); o.setAttribute('aria-expanded', 'false'); });
        g.classList.toggle('open', open); g.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) track('sneak_peek', { item: g.getAttribute('data-item') });
      });
    });
  }

  /* ---------- live: filters, copy code, product clicks ---------- */
  function initLive() {
    var fb = root.querySelectorAll('[data-filter]');
    fb.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-filter');
        fb.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        root.querySelectorAll('[data-for]').forEach(function (c) { c.hidden = v !== 'all' && c.getAttribute('data-for') !== v; });
      });
    });
    root.querySelectorAll('[data-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-copy');
        var done = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 2000); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {}); else done();
        track('copy_code');
      });
    });
    root.querySelectorAll('[data-product]').forEach(function (a) {
      a.addEventListener('click', function () { track('select_item', { item_name: a.getAttribute('data-product') }); });
    });
  }

  /* ---------- closed: keep me on the list ---------- */
  function initWaitlist() {
    var f = root.querySelector('[data-waitlist]');
    if (!f) return;
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = f.querySelector('[name="email"]'), out = f.parentNode.querySelector('[data-ok]');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim())) { em.setAttribute('aria-invalid', 'true'); em.focus(); out.textContent = 'Please check your email address.'; return; }
      var btn = f.querySelector('button'); btn.disabled = true;
      fetch(CFG.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em.value.trim(), list: 'waitlist', website: f.querySelector('[name="website"]').value }), credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.ok) throw 0; }); })
        .then(function () { out.textContent = 'You are on the list. You will hear first.'; f.reset(); track('generate_lead', { form: 'halloween_waitlist' }); })
        .catch(function () { out.textContent = 'Sorry, that did not go through. Please try again.'; })
        .then(function () { btn.disabled = false; });
    });
  }

  /* ---------- sticky bar (mobile): shows once the main action has scrolled away ---------- */
  function initSticky() {
    var bar = root.querySelector('.pgxh-sticky');
    if (!bar || !('IntersectionObserver' in window)) return;
    var watch = root.querySelectorAll('[data-sticky-watch]');
    var vis = new Map();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { vis.set(e.target, e.isIntersecting); });
      var anyVisible = false;
      watch.forEach(function (w) { if (w.offsetParent !== null && vis.get(w)) anyVisible = true; });
      bar.classList.toggle('on', !anyVisible && state !== 'closed');
    }, { threshold: 0 });
    watch.forEach(function (w) { io.observe(w); });
  }

  /* ---------- background video (desktop only, if configured) ---------- */
  function initVideo() {
    var v = root.querySelector('video[data-src]');
    if (!v || reduce || !matchMedia('(min-width:1024px)').matches) return;
    v.src = v.getAttribute('data-src'); v.hidden = false; v.play && v.play().catch(function () {});
  }

  /* ---------- test bar (only when allowPreview and no key is configured, i.e. the test site) ---------- */
  function renderTestBar() {
    var bar = document.getElementById('pgxh-test');
    if (!bar) return;
    bar.querySelectorAll('[data-s]').forEach(function (a) {
      if (a.getAttribute('data-s') === (forced || 'clock')) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }

  setState(state);
  tick();
  setInterval(tick, 1000);
  initGate(); initRsvp(); initGhosts(); initLive(); initWaitlist(); initSticky(); initVideo();
})();